
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `輕觸「在瀏覽器中開啟…」`,
's182ab2d6c997515f': `將其加入主畫面，以獲得更完整的體驗並方便存取。`,
's224cbcec014ef6b5': `點擊導覽列中的「分享」按鈕`,
's233af3b7eb5e0364': `加入首頁`,
's37a9e8aec5713460': `更多`,
's4c3161035f3a1413': `請點擊「選單」`,
's4e1e10a6ca408245': `輕觸「加入主畫面」`,
's6196153c4b0c1ea0': `安裝`,
's633502f7cff4f847': `開啟瀏覽器選單`,
's681e399d63311fba': `顯示相簿`,
's6d14a4f70ba4e3cf': `若未看見「分享」圖示，請點擊「選單」`,
's922329d6f6213590': `加入 Dock`,
's9c63a79ffcc2a3a3': `點擊「加入主畫面」`,
'sa2d71bfd9525168d': `點擊「加入 Dock」`,
'sa5ef80b4bb9b39f8': `收起`,
'sb527eca1c1d7e7be': `開啟應用程式內的瀏覽器選單`,
'sba52286c21552a4e': `在您的裝置上安裝，以獲得更完整的體驗並方便存取。`,
'sc16e00a7a8b2fde2': `返回`,
'scdaf4bbff76674c8': `加入主畫面`,
'sd18a5b85f599ff3c': `在 Safari 中開啟已複製的連結`,
'se72fc3a84f9b51c3': `點一下以複製連結`,
'se740f75b95a51807': `將其加入 Dock，以獲得更完整的體驗並方便隨時存取。`,
'sfa6c42cdf48d93d2': `但此瀏覽器不支援此功能。請在外部瀏覽器中開啟連結以繼續。`,
'sfb78526365796a41': `在分享選單中點擊「查看更多」`,
'sfea652f6580ff086': `此網站具備應用程式功能。`,
    };
  